import * as pdfjsLib from 'pdfjs-dist';
import { getPrintPrice } from './apiService';

// Set the worker source
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

export const numPages = async (file) => {
    switch (file.type) {
        case "application/pdf":
            return (await pdfjsLib.getDocument({ data: await file.arrayBuffer() }).promise)._pdfInfo.numPages;
        // because to accurately calculate the number of pages for .docx files, we need to use a different library
        // to convert the docx file to a pdf file first, and the conversion process is gonna detriorate the
        // performance of the application, so we will just return null for now
        // and should be calculated in the backend
        // case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        default:
            return null;
        }
};

export const getPrintingPrice = async (fileInputs) => {
    let totalPrice = 0;
    const printPrice = await getPrintPrice();

    for (const fileInput of fileInputs) {
        let numberPages = 0;
        if (fileInput.pageRange === 'All Pages') {
            numberPages = await numPages(fileInput.file);
            if (numberPages === null) {
                return null;
            }
        } else {
            numberPages = fileInput.pageRange.split(';').reduce((accumulator, range) => {
                const [start, end] = range.split('-');
                return accumulator + (end ? (parseInt(end) - parseInt(start) + 1) : 1);
            }, 0);
        }

        totalPrice += (
            numberPages *
            printPrice.optionsPricing[
                `${fileInput.paperFormat};${fileInput.printColor};${fileInput.printOption}`
            ] + printPrice.fasteningPricing[fileInput.paperFasteningChoice]
        ) * fileInput.quantity;
    }

    return totalPrice;
}